// Dopo un deploy i chunk delle route lazy della versione precedente non
// esistono più. Un tab rimasto aperto da prima del deploy non riesce a caricare
// la route e vue-router annulla la navigazione in silenzio: il clic su link e
// card non fa nulla finché l'utente non ricarica (#736). Qui si ricarica noi,
// direttamente sulla pagina richiesta, così arriva la versione nuova.
//
// Il reload porta un parametro `_r` (RELOAD_PARAM) che cambia l'URL: la CDN
// davanti a Hosting tiene in cache l'HTML delle pagine fino a 10 minuti, e un
// HTML della versione precedente punta ai bundle appena cancellati → pagina
// bianca. Con l'URL nuovo la CDN chiede la pagina aggiornata. index.html toglie
// il parametro dalla barra degli indirizzi appena la pagina parte.
//
// Il timestamp in sessionStorage evita un ciclo di reload se il chunk manca
// davvero: entro RELOAD_WINDOW_MS dal reload precedente non si ricarica di
// nuovo e l'errore resta solo in console, come prima.

export const CHUNK_RELOAD_KEY = 'chunkReloadAt';
export const RELOAD_WINDOW_MS = 10000;
// Tenuto allineato con lo script inline in public/index.html.
export const RELOAD_PARAM = '_r';

// `path` con `_r=<now>` in coda alla query (prima dell'eventuale #hash).
export function withReloadParam(path, now) {
  const hashAt = path.indexOf('#');
  const base = hashAt >= 0 ? path.slice(0, hashAt) : path;
  const hash = hashAt >= 0 ? path.slice(hashAt) : '';
  return `${base}${base.includes('?') ? '&' : '?'}${RELOAD_PARAM}=${now}${hash}`;
}

// webpack: "ChunkLoadError: Loading chunk 123 failed." / "Loading CSS chunk …";
// i browser, per gli import() nativi: "Failed to fetch dynamically imported
// module" (Chrome), "error loading dynamically imported module" (Firefox),
// "Importing a module script failed" (Safari).
const CHUNK_ERROR_RE = /ChunkLoadError|Loading (CSS )?chunk \S+ failed|dynamically imported module|Importing a module script failed/i;

export function isChunkLoadError(error) {
  if (!error) return false;
  return CHUNK_ERROR_RE.test(`${error.name || ''} ${error.message || ''}`);
}

// Ritorna true se ha avviato il reload.
export function reloadOnChunkError(error, to, {
  storage = safeSessionStorage(),
  location = window.location,
  now = Date.now(),
} = {}) {
  if (!isChunkLoadError(error)) return false;

  // Senza sessionStorage non c'è modo di evitare un ciclo di reload: meglio
  // lasciare le cose come prima.
  try {
    const lastReload = Number(storage.getItem(CHUNK_RELOAD_KEY)) || 0;
    if (now - lastReload < RELOAD_WINDOW_MS) return false;
    storage.setItem(CHUNK_RELOAD_KEY, String(now));
  } catch (e) {
    return false;
  }

  location.assign(withReloadParam(to && to.fullPath ? to.fullPath : location.href, now));
  return true;
}

function safeSessionStorage() {
  try { return window.sessionStorage; } catch (e) { return null; }
}
